module.exports = __webpack_public_path__ + "static/fonts/Fact-Thin.dee1057.ttf";